import { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useInView } from "react-intersection-observer";
import { Button, IconButton, Loading } from "../../components";
import { TextInput } from "../forms";
import { PlusCircleIcon, SearchIcon } from "../../assets/icons";
import useCustomerService from "../../services/api/customerService";
import "./NotificationTabs.scss";

export default function CustomerListTab({ onAddCustomer }) {
  const [search, setSearch] = useState("");
  const { getAllCustomers, queryKey } = useCustomerService();
  const { ref, inView } = useInView();

  const {
    data: customersData,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
  } = useInfiniteQuery({
    queryKey: [queryKey, "all", search],
    queryFn: ({ pageParam = 1 }) =>
      getAllCustomers(search, undefined, pageParam),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage?.totalPages > lastPage?.currentPage) {
        return lastPage?.currentPage + 1;
      }
      return undefined;
    },
  });

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  return (
    <div className="contact-list-container">
      <div className="search-bar">
        <Formik
          initialValues={{ search: "" }}
          onSubmit={(values) => setSearch(values.search)}
        >
          <Form>
            <TextInput
              name="search"
              placeholder="Enter customer name"
              className="search-input"
            />
            <IconButton
              type="submit"
              icon={<SearchIcon className="search-icon" />}
            />
          </Form>
        </Formik>
      </div>

      <div className="contact-list">
        <div className="table-content">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {customersData?.pages
                .flatMap((page) => page.customers)
                .map((contact) => (
                  <tr key={contact._id}>
                    <td>{contact.name}</td>
                    <td>
                      <Button
                        text="Add"
                        icon={<PlusCircleIcon />}
                        onClick={() =>
                          onAddCustomer && onAddCustomer({ id: contact._id, name: contact.name })
                        }
                        className="action-btn"
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px 0",
            }}
            ref={ref}
          >
            {isFetchingNextPage || isLoading ? (
              <Loading variant="inline" />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
